module.exports = __webpack_public_path__ + "static/media/evento-anime-pocket-canopla-personalizada.07055201.jpg";